import store from "../../store/index";
import axios from "axios";
import { MULTA_URL } from "@/env";
import setTokenUser from "../office/tokens/refreshTokenUser";
import GeneralFunctions from "../helpers/generalFunctions";
import setTokenMuni from "../office/tokens/refreshTokenMuni";
import { useToast } from "vue-toastification";

const toast = useToast();

const apiInfraction = axios.create({
  baseURL: MULTA_URL,
});

apiInfraction.interceptors.request.use(
  (config) => {
    const currentToken = localStorage.getItem("token");
    if (currentToken) {
      console.log("token ", currentToken);
      config.headers["auth-header"] = `${currentToken}`;
    }
    return config;
  },
  (error) => {
    console.log("hubo un error en cambiar el token", error);
    return Promise.reject(error);
  },
);

apiInfraction.interceptors.response.use(
  (response) => response, // Para manejar respuestas exitosas.
  async (error) => {
    // Verificar si el error es debido a token expirado
    if (error.response?.status === 401) {
      const originalRequest = error.config;

      if (error.response.data?.message === "Token de usuario expirado") {
        try {
          const user = store.state?.user;

          let success = false;
          //alert("state user exio ", user)
          if (user?.role) {
            success = await setTokenMuni();
          } else {
            success = await setTokenUser();
          }

          if (!success) {
            console.log("Fallo la renovación del token, cerrando sesión...");
            await GeneralFunctions.logOutOffice();
            return Promise.reject(error);
          }

          // Actualizar el token en los headers y reintentar la solicitud original
          let newToken = localStorage.getItem("token");
          newToken = store.state.token ?? newToken;
          if (newToken) {
            originalRequest.headers["Authorization"] = `${newToken}`;
          }

          // Reintentar la solicitud
          return apiInfraction(originalRequest);
        } catch (refreshError) {
          console.error("Error al renovar el token", refreshError);
          // Opcional: Redirigir al usuario al inicio de sesión
          await GeneralFunctions.logOutOffice();
          return Promise.reject(refreshError);
        }
      } else if (error.response.data?.message === "CIDI_ERR_EXP") {
        toast.error("Sesion en CIDI expirada, vuelve a ingresar.");
        await new Promise((resolve) => setTimeout(resolve, 3000));
        await GeneralFunctions.logOutOffice();
      } else if (error.response.data?.message === "ACTION_NEED_LVL") {
        toast.error("Nivel en el area insuficiente, contacte a su supervisor.");
      }
    }

    // Si el error no está relacionado con el token expirado
    //await GeneralFunctions.logOutOffice();
    return Promise.reject(error);
  },
);

export default apiInfraction;
